import styled from 'styled-components';

export const ModelCardContainer = styled.div`
  width: 100%;
`;

export const ModelCardColumn = styled.div`
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ModelCardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 54px;
`;

export const ModelName = styled.div`
  min-width: 0;
  flex: 1;
`;

export const EditAction = styled.div`
  flex-shrink: 0;
`;
